import React from 'react';

import SvgIcon from '../SvgIcon';
import { direction, IconProps } from '../types';

interface ArrowIconProps extends IconProps {
  direction?: direction;
}

const ArrowIcon: React.FC<ArrowIconProps> = ({ className, size, disabled, direction = 'up' }) => (
  <SvgIcon
    viewBox="0 0 16 16"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={1}
    stroke="none"
    fill="none"
    direction={direction}
  >
    <g clipPath="url(#a)" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 13.5v-11M3.5 7 8 2.5 12.5 7" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="none" stroke="none" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default ArrowIcon;
